import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { MediaType, MetaProps, RatingSummary, RecipeMetaSectionProps } from '@repo/ui/src/types';
import RatingStars from '@repo/ui/src/components/RatingStars';
import Image from '@repo/ui/src/components/Image';
import { Anchor } from '@repo/ui/src/components/Anchor';
import Button, { ButtonVariant } from '@repo/ui/src/components/Button';

interface Props {
  _meta: MetaProps;
  recipeMetaSection: RecipeMetaSectionProps;
  assets: Array<MediaType>;
  darkMode?: boolean;
  recipeMigrationSection: any;
  ratingSummary: RatingSummary;
}

const RecipeCard = ({ recipeMetaSection, assets, _meta, darkMode, ratingSummary }: Props) => {
  const imageUrl = buildImageSrc(assets?.length ? assets[0] : null, 700, 2, 1);
  const link = {
    displayName: 'View the Recipe',
    link: _meta?.deliveryKey,
  };

  if (!recipeMetaSection) return null;

  return (
    <div className="tw-grid tw-grid-rows-[auto_3fr_auto] tw-h-full tw-bg-white tw-border tw-border-warm-300">
      <Anchor
        link={link.link}
        className="tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-full tw-z-10"
        tabIndex={-1}
        label={recipeMetaSection?.title}
      />
      <div className="tw-relative tw-h-[200px]">
        <Image
          src={imageUrl}
          alt={recipeMetaSection?.title}
          layout="fill"
          height={250}
          width={250}
          objectFit="cover"
        />
      </div>

      <div data-testid="rc-header" className="tw-flex tw-flex-col tw-h-full tw-pt-6 tw-px-6">
        <h4 className="tra-text-web-heading-6 tw-text-left">{recipeMetaSection?.title}</h4>
        {ratingSummary?.average && (
          <div className="tw-pt-2">
            <RatingStars value={ratingSummary?.average} />
          </div>
        )}
      </div>
      <div className="tw-px-6 tw-pt-12 tw-pb-8">
        <Button
          {...link}
          as={Anchor}
          variant={ButtonVariant.knife}
          dark={!!darkMode}
          className="tw-z-20"
          size="small"
        >
          {link?.displayName}
        </Button>
      </div>
    </div>
  );
};

export default RecipeCard;
